module.exports = __webpack_public_path__ + "assets/e151d867220871dc27145b6142668737.mp3";